import React from 'react'
import styles from './Heading.module.scss'

type Level = 1 | 2 | 3 | 4 | 5 | 6
type Tag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'

interface HeadingProps {
  children: React.ReactNode
  level?: Level
  className?: never
}

const sizeMap: Record<Level, string> = {
  1: styles.h1, 2: styles.h2, 3: styles.h3, 4: styles.h4, 5: styles.h5, 6: styles.h6,
}

export const Heading: React.FC<HeadingProps> = ({ children, level = 2 }) => {
  const Tag = `h${level}` as Tag
  return <Tag className={[styles.heading, sizeMap[level]].join(' ')}>{children}</Tag>
}
